// src/hooks/useAmendmentDiff.js
// SCREENER-FINANCIALS — new file. Fetched ON DEMAND only (when a member
// actually clicks to view the diff), never eagerly for every amended period
// on the page — most members will never click most amendment badges.

import { useState, useCallback } from 'react';
import apiFetch from '../utils/apiFetch';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export function useAmendmentDiff() {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const fetchDiff = useCallback((ticker, fiscalYear, fiscalPeriod) => {
    setLoading(true);
    setError('');
    setData(null);
    return apiFetch(API_URL + '/api/financials/amendment-diff/' + encodeURIComponent(ticker) + '/' + fiscalYear + '/' + fiscalPeriod)
      .then(r => r.json())
      .then(res => {
        if (!res.success) { setError(res.message || 'Amendment diff unavailable'); return; }
        setData(res);
      })
      .catch(() => setError('Failed to load amendment diff'))
      .finally(() => setLoading(false));
  }, []);

  return { data, loading, error, fetchDiff };
}
